"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _removeCallback(globalStateManager, callback) {
    return globalStateManager.removeCallback(callback);
}
exports.default = _removeCallback;
;
